













import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../system/mixins";
import { StandardOption } from "../../../system/selectors/mixins";
import OptionDropDownSelector from "../../../system/selectors/OptionDropDownSelector.vue";

@Component({
  components: {
    selector: OptionDropDownSelector,
  },
})
export default class TimeFormatEditor extends Mixins(ModelEditableMixin) {
  editingSource: string;

  get formats(): StandardOption<string>[] {
    const configuration = this.$configuration.behavior.document.entities.time;
    // 本来であればバックエンドからフォーマットXMLのvisible属性の7bit目を見てフロントに情報を渡すべき
    if (!configuration) { return []; }
    return this.editingSource.indexOf("ss") >= 0
      ? Enumerable.from(configuration.formatsIncludeSecond).select(c => new StandardOption<string>(c.label, c.format)).toArray()
      : Enumerable.from(configuration.formats).select(c => new StandardOption<string>(c.label, c.format)).toArray();
  }

  get format(): string {
    return this.editingSource;
  }

  set format(value: string) {
    this.editingSource = value;
  }
}
